import { CloudFile } from 'owa-attachment-file-types';
import {
    CreateSharingLinkFromFileProviderResult,
    GetGDriveSharingInfoResponse,
    TEXT_DIRECTORY_MIME_TYPE,
} from 'owa-fileprovider-link-services';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import { getSharingLinkKindFromCreateSharingLinkFromFileProviderResult } from './getSharingLinkKindFromCreateSharingLinkFromFileProviderResult';

export function createGetGDriveSharingInfoResponse(
    file: CloudFile,
    createLinkResult: CreateSharingLinkFromFileProviderResult
): GetGDriveSharingInfoResponse {
    return {
        ResultCode: AttachmentResultCode.Success,
        FileName: file.name,
        MimeType: file.isFolder ? TEXT_DIRECTORY_MIME_TYPE : file.type,
        SharingLinkKind: getSharingLinkKindFromCreateSharingLinkFromFileProviderResult(
            createLinkResult,
            file.providerType
        ),
        BlocksDownload: false,
        CanShareExternally: true,
        CanCreateAnonymousEditLink: true,
        CanCreateAnonymousViewLink: true,
        ExpirationDate: null,
        OriginalUrl: null,
        Type: createLinkResult.link.type,
        providerFileId: file.fileId, // same as file.location, e.g. 1RF6ADqmuwVHiu89b6XILKUrx_wJobxefNBU-0yNen04
    };
}
